const userContract = () => ({
    id: null,
    email: '',
    isActiveSubscription: false,
    onboarding: {},
    subscriptionFeatures: [],
    isAuthenticated: false
});

function createUser(user) {
    return Object.assign(userContract(), user);
}

export {
    createUser
};
